require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reviews-gamebreaker-pro-d-3-o.json") })
        }
      }, "path---reviews-gamebreaker-pro-d-3-o");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reviews-gamebreaker-pro-d-3-o!./.cache/json/reviews-gamebreaker-pro-d-3-o.json
// module id = 685
// module chunks = 231608221292675